var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFixthestatusquo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 518.8 155.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C39",
    d: "M85.4 0a78 78 0 0 0-78 78v1.2l35-20.4 41 23.7v48.4L53 148.8A78 78 0 1 0 85.4 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#54585A",
    d: "M7.5 79.2 0 83.6V132l41 23.8 11.9-7A78 78 0 0 1 7.5 79.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 23.9,
    y1: 126.7,
    x2: 75.7,
    y2: 74.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff5c39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#485cc7"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m42.4 58.8-35 20.4A78 78 0 0 0 53 148.8l30.5-17.9V82.5l-41-23.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.2 59.2h23v4.6h-8.8v27.1h-5.2V63.8h-9v-4.6zm46.4 18H206V91h-5.2V59.2h5.2v13.5h13.6V59.2h5.2V91h-5.2V77.2zm12.3-18h20v4.5H237v9h12.1V77h-12v9.3h14.8v4.5h-20V59.2zM287 64s-6.4-.8-9.1-.8c-3.9 0-5.9 1.4-5.9 4.1 0 3 1.7 3.7 7 5.2 6.8 1.8 9.2 3.6 9.2 9 0 7-4.4 10-10.6 10-4.2 0-10.4-1.3-10.4-1.3l.5-4.1s6.3.8 9.5.8c4 0 5.8-1.8 5.8-5.1 0-2.7-1.5-3.6-6.3-4.8-6.9-1.7-9.8-3.8-9.8-9.3 0-6.4 4.2-9 10.5-9 4 0 10 1 10 1L287 64zm4.5-4.8h23.1v4.6h-9v27.1h-5.1V63.8h-9v-4.6zm30.7 0h10.2l7.9 31.7h-5.2l-1.7-6.8h-12.2l-1.7 6.8h-5.1l7.8-31.7zm0 20.4h10.2l-3.9-16h-2.3l-4 16zM340 59.2h23.2v4.6h-9v27.1h-5.1V63.8h-9v-4.6zM379.2 87c4.3 0 6.5-2 6.5-6.2V59.2h5.2v21.5c0 7.6-4.1 10.7-11.7 10.7-7.5 0-11.6-3-11.6-10.7V59.2h5.2v21.6c0 4.3 2.2 6.1 6.4 6.1zm37-23s-6.4-.8-9.1-.8c-3.9 0-5.9 1.4-5.9 4.1 0 3 1.7 3.7 7.1 5.2 6.7 1.8 9 3.6 9 9 0 7-4.3 10-10.5 10-4.1 0-10.4-1.3-10.4-1.3l.5-4.1s6.3.8 9.5.8c4 0 5.8-1.8 5.8-5.1 0-2.7-1.5-3.6-6.3-4.8-6.9-1.7-9.8-3.8-9.8-9.3 0-6.4 4.2-9 10.5-9 4 0 10 1 10 1l-.4 4.2zm32.2 27.1c-.6.2-1.8.3-2.9.3-9.9 0-12.9-5.4-12.9-16.2 0-10.6 3-16.5 13-16.5 9.8 0 12.8 5.9 12.8 16.5 0 7.2-1.3 11.8-5 14.2l3.9 6.3-4.8 2.2-4.1-6.8zm4.7-15.9c0-7.8-1.4-12-7.6-12-6 0-7.5 4.2-7.5 12 0 8 1.4 11.7 7.5 11.7 6.2 0 7.6-3.6 7.6-11.7zM475.7 87c4.3 0 6.5-2 6.5-6.2V59.2h5.2v21.5c0 7.6-4.1 10.7-11.7 10.7-7.5 0-11.6-3-11.6-10.7V59.2h5.2v21.6c0 4.3 2.2 6.1 6.4 6.1zM493 75.2c0-10.6 3-16.5 13-16.5 9.9 0 12.8 5.9 12.8 16.5 0 10.8-3 16.2-12.8 16.2-10 0-13-5.5-13-16.2zm20.5 0c0-7.8-1.4-12-7.5-12s-7.6 4.2-7.6 12c0 8 1.4 11.7 7.6 11.7 6.1 0 7.5-3.6 7.5-11.7z",
    fill: "#54585A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89 58.8h23.4v9.1h-12.2v5.3h9.3v9.1h-9.3v9H89V58.7zm28 0h11v32.4h-11V58.8zm44 32.4L154.1 76l6.9-17.2h-11.3l-2.8 9.1-2.8-9.1h-11.2l7 17.2-7.1 15.2H144l2.9-8.9 2.9 8.9z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixthestatusquo);
export default __webpack_public_path__ + "static/media/fixthestatusquo.83b2d6c4.svg";
export { ForwardRef as ReactComponent };